import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import DashboardManager from "./admin/DashboardManager"
import ShowsManager from "./admin/ShowsManager"
import GamesManager from "./admin/GamesManager"
import AskForsManager from "./admin/AskForsManager"
import SuggestionsViewer from "./admin/SuggestionsViewer"
import ColorsManager from "./admin/ColorsManager"

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState("dashboard")

  const tabs = [
    { id: "dashboard", label: "Dashboard" },
    { id: "shows", label: "Shows" },
    { id: "games", label: "Games" },
    { id: "askfors", label: "Ask Fors" },
    { id: "suggestions", label: "Suggestions" },
    { id: "colors", label: "Colors" }
  ]

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-7xl mx-auto">
        <Link
          to="/"
          className="inline-block mb-6 text-cyan-600 hover:text-cyan-700 font-semibold"
        >
          ← Back to Home
        </Link>

        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="p-8 border-b border-gray-200">
            <h1 className="text-4xl font-bold text-gray-800">
              Admin Dashboard
            </h1>
          </div>

          {/* Tab Navigation */}
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-8" aria-label="Tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    py-4 px-1 border-b-2 font-medium text-sm
                    ${
                      activeTab === tab.id
                        ? "border-cyan-500 text-cyan-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }
                  `}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-8">
            {activeTab === "dashboard" && <DashboardManager />}
            {activeTab === "shows" && <ShowsManager />}
            {activeTab === "games" && <GamesManager />}
            {activeTab === "askfors" && <AskForsManager />}
            {activeTab === "suggestions" && <SuggestionsViewer />}
            {activeTab === "colors" && <ColorsManager />}
          </div>
        </div>
      </div>
    </div>
  )
}
